import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { apiErrorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Sparkles, Shield } from "lucide-react";

export default function SuperAdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      if (u.role !== "super_admin") { toast.error("Not a super admin"); return; }
      navigate("/super-admin");
    } catch (err) {
      toast.error(apiErrorMessage(err, "Login failed"));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-mr-bg flex items-center justify-center p-8">
      <div className="w-full max-w-md bg-white border border-mr rounded-3xl p-10">
        <Link to="/" className="inline-flex items-center gap-2 mb-10">
          <div className="h-8 w-8 rounded-lg bg-mr-primary text-white flex items-center justify-center"><Sparkles className="h-4 w-4" /></div>
          <span className="font-display font-semibold text-mr-primary">MedRewards · Platform</span>
        </Link>
        <h1 className="font-display text-3xl font-semibold text-mr-primary flex items-center gap-2"><Shield className="h-7 w-7 text-mr-accent" /> Platform sign in</h1>
        <p className="text-mr-secondary mt-2">Manage all clinics on MedRewards.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div><Label>Email</Label><Input data-testid="super-email-input" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 rounded-xl bg-white border-mr h-11" /></div>
          <div><Label>Password</Label><Input data-testid="super-password-input" required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 rounded-xl bg-white border-mr h-11" /></div>
          <Button data-testid="super-submit-btn" type="submit" disabled={busy} className="w-full h-11 rounded-full bg-mr-primary hover:bg-[var(--mr-primary-hover)]">{busy ? "…" : "Sign in"}</Button>
        </form>
      </div>
    </div>
  );
}
